export default {"src":"/_next/static/media/api.61e558ac.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};